

import Gallery from '../../../../modules/Gallery';


import foto_1 from './foto_1.jpg'
import foto_2 from './foto_2.jpg'
import foto_3 from './foto_3.jpg'
import foto_4 from './foto_4.jpg'


const slides = [
    {
      src: foto_1,
      title: 'Slide Title One',
      description: 'Slide Description One\n\nthis is new line',
    },
    {
      src: foto_2,
      title: 'Slide Title Two',
      description: 'Slide Description Two',
    },
    {
      src: foto_3,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    },
    {
      src: foto_4,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    }
]



export default function Index() {

    return (
        <div className='container'>

            <div className='mt-3'>
                <h3>Artesanos de Taganga</h3>
                <p>
                    COOPMULMAG, en cumplimiento de su misión de orientación socio empresarial, 
                    promueve estrategias para el fortalecimiento de una economía solidaria y 
                    sostenible. En esta ocasión, auspicia espacios de capacitación y acompañamiento 
                    técnico-profesional dirigidos a artesanos de Santa Marta, 
                    apoyando sus procesos de formalización y fomentando la creación de nuevas 
                    Mi Pymes como motor de desarrollo local.</p>
            </div>
            <Gallery slides={slides} ></Gallery>
        </div>
    )

}